module.exports = __webpack_public_path__ + "static/media/call_status_released_hover.dfcd7fb4.svg";